<!--
 * @Author: 汪俊洪
 * @Date: 2022-02-28 16:53:16
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-03-09 14:03:16
 * @Description: 管理模板
-->
<template>
  <div class="col-wrap">
    <div class="col pad">
      <el-table
        :data="leftData"
        highlight-current-row
        @row-click="rowClick"
        border
        height="400px"
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column prop="name" align="center" label="模板名称">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleUse(scope.row)"
              >应用</el-button
            >
            <el-button type="text" size="small" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="col">
      <el-table :data="rightData" border height="400px">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column prop="code" align="center" label="字段">
        </el-table-column>
        <el-table-column prop="name" align="center" label="标题">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sysListCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      leftData: [],
      rightData: []
    }
  },
  created () {
    this.doSearch()
  },
  methods: {
    rowClick (row) {
      this.$http
        .get(
          `/help/user-list-mgmt/v1/user-list-templates/${row.id}/selected-fields`
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.rightData = res.data
          }
        })
    },
    // 搜索查询
    doSearch () {
      const url = `/help/user-list-mgmt/v1/user-list-templates?sysListCode=${this.sysListCode}`
      this.$http
        .get(url, {
          params: {
            currentPage: 1,
            pageSize: 1000
          }
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.leftData = res.data.dataList
          }
        })
    },
    // 应用
    handleUse (row) {
      this.$confirm(`确定要应用【${row.name}】模板吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('handleUse', {
          ...row,
          data: this.rightData
        })
      })
    },
    // 删除
    handleDelete (row) {
      this.$confirm('确定要删除该模板吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDelete(row.id)
      })
    },
    doDelete (id) {
      this.$http
        .delete(`/help/user-list-mgmt/v1/user-list-templates/${id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.doSearch()
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.col-wrap {
  display: flex;
  padding: 12px 0 0;
  .col {
    flex: 1;
    display: flex;
    height: 400px;
    &.pad {
      padding-right: 12px;
    }
    .table-wrap {
      background: #0f0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
